<template>
  <Multiselector
    v-if="options.length"
    :id="getRandomId('children-groups-select')"
    :model-value="selectedValues"
    :options="options"
    :placeholder="$t('Choose group')"
    :main-input-label="hideLabel ? '' : (label ?? $t('Groups'))"
    :multiple="multiple"
    v-bind="$attrs"
    :label-class="labelClass"
    :container-class="containerClass"
    @update:model-value="updateSelected"
  />
</template>

<script>
import { useTrackFormLoading } from "@/components/newUi/core/useFormLoading";
import Multiselector from "@/components/Multiselector.vue";
import { getRandomId } from "@/utils/string";

export default {
  name: "ChildrenGroupsSelect",

  components: {
    Multiselector,
  },

  model: {
    prop: "selected",
    event: "change",
  },

  props: {
    selected: {
      type: [Number, Array],
      default: null,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    hideLabel: {
      type: Boolean,
      default: false,
    },

    defaultOptions: {
      type: [Array, null],
      default: null,
    },

    labelClass: {
      type: String,
      default: null,
    },

    containerClass: {
      type: String,
      default: null,
    },

    label: {
      type: String,
      default: null,
    },
  },

  emits: ["change"],

  setup() {
    return { trackFormLoading: useTrackFormLoading() };
  },

  data() {
    return {
      allOptions: [],
    };
  },

  computed: {
    selectedValues() {
      return this.selected ? (this.multiple ? this.selected : [this.selected]) : [];
    },

    options() {
      return this.allOptions;
    },
  },

  watch: {
    defaultOptions(newVal) {
      if (newVal) {
        this.allOptions = newVal;
      }
    },
  },

  async mounted() {
    const criteria = {
      withInstitutionsIds: true,
    };

    this.allOptions = this.defaultOptions || [
      ...(await this.trackFormLoading(this.$store.dispatch("childrenGroups/getOptions", criteria))),
    ];
  },

  methods: {
    getRandomId,

    updateSelected(values) {
      if (!this.multiple && Array.isArray(values)) {
        values = values[0];
      }

      this.$emit("change", values);
    },
  },
};
</script>
